/*
 * Copyright (c) 2019 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

export const isEmptyValidation = (fieldName = ''): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
  };

  return _isEmptyValidation.bind(funcProperties);
};

function _isEmptyValidation(this: any, control: AbstractControl): { [key: string]: any } | null {
  let errors: ErrorModel | null = null;

  if (control.value) {
    if (
      Object.keys(control.value).length === 0 ||
      (Array.isArray(control.value) && control.value.length === 0)
    ) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: 'isEmpty' + this.field,
      };
    }
  } else {
    errors = {
      severity: ErrorSeverityEnum.error,
      message: 'isEmpty' + this.field,
    };
  }

  return errors ? errors : null;
}
